module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "placeInTop": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [(_vm.theEditItem) ? _c('h2', [_vm._v("Redigér lønbrøk")]) : _c('h2', [_vm._v("Opret lønbrøk")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg ansat *")]), _vm._v(" "), _c('DSelect', {
    ref: "userSelect",
    attrs: {
      "items": _vm.filteredUsers,
      "multiple": false,
      "placeholder": 'Vælg ansat',
      "itemsSelected": _vm.itemsSelectedForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectUser,
      "remove": function($event) {
        return _vm.onSelectUser(null)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Ansættelse *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentId),
      expression: "employmentId"
    }],
    staticClass: "height-34 do-select width-100",
    attrs: {
      "disabled": !_vm.userId || !_vm.hasEmploymentsWithNumber
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.employments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n                " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number) + "\n                ")])
  }), 0), _vm._v(" "), (_vm.userId && !_vm.hasEmploymentsWithNumber) ? _c('p', {
    staticClass: "text-explainer marg-05-top"
  }, [_vm._v("\n                Den valgte bruger har ingen ansættelser med tjenestenummer\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs-container marg-05-top"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.activeTab
    },
    on: {
      "select": _vm.changeTab
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'timer') ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Årsnorm")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aarstimetal),
      expression: "aarstimetal"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "Timer"
    },
    domProps: {
      "value": (_vm.aarstimetal)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.aarstimetal = $event.target.value
      }, _vm.onHoursInput]
    }
  }), _vm._v(" "), (_vm.hoursError) ? _c('p', {
    staticClass: "text-explainer marg-05-top",
    staticStyle: {
      "color": "#e53e3e"
    }
  }, [_vm._v("\n                Maksimal værdi er 1924\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'loenbroek') ? _c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Løndecimal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loendecimal),
      expression: "loendecimal"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "Løndecimal",
      "inputmode": "decimal",
      "pattern": "[0-9]+([,\\.][0-9]{1,2})?"
    },
    domProps: {
      "value": (_vm.loendecimal)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.loendecimal = $event.target.value
      }, _vm.onLoendecimalInput]
    }
  }), _vm._v(" "), (_vm.loendecimalError) ? _c('p', {
    staticClass: "text-explainer marg-05-top",
    staticStyle: {
      "color": "#e53e3e"
    }
  }, [_vm._v("\n                    Maksimal værdi er 1\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Beskæftigelsesdecimal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beskaefftigelsesdecimal),
      expression: "beskaefftigelsesdecimal"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": "Beskæftigelsesdecimal",
      "inputmode": "decimal",
      "pattern": "[0-9]+([,\\.][0-9]{1,2})?"
    },
    domProps: {
      "value": (_vm.beskaefftigelsesdecimal)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.beskaefftigelsesdecimal = $event.target.value
      }, _vm.onBeskaaefftigelsesdecimalInput]
    }
  }), _vm._v(" "), (_vm.beskaefftigelsesdecimalError) ? _c('p', {
    staticClass: "text-explainer marg-05-top",
    staticStyle: {
      "color": "#e53e3e"
    }
  }, [_vm._v("\n                    Maksimal værdi er 1\n                ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Dato det skal gælde fra")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.startDate,
      "width100": true
    },
    on: {
      "changed": function($event) {
        return _vm.setDate($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [(_vm.theEditItem) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isDeleteModal = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), (!_vm.theEditItem) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSubmitting,
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.theEditItem ? 'Opret ny' : 'Gem') + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.isDeleteModal) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isDeleting
    },
    on: {
      "close": function($event) {
        _vm.isDeleteModal = false
      },
      "confirm": _vm.deleteEditItem
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57f23845!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/LoenbroekModal.vue
// module id = 1936
// module chunks = 1